/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

( function () {
	'use strict';

	const container = document.getElementById( 'site-navigation' );
	if ( !container ) {
		return;
	}

	const button = container.querySelector( '.menu-toggle' );
	if ( ! button ) {
		return;
	}

	const menu = document.getElementById( 'primary-menu' );
	if ( ! menu ) {
		button.style.display = 'none';
		return;
	}

	menu.setAttribute( 'aria-expanded', 'false' );
	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	const menucontainer = document.getElementById( 'mobile-navigation' );

	function setToggleState( toggleButton, isOpen ) {
		const openLabel = window.berlinMediaGroupData?.strings?.openSubmenuText || '';
		const closeLabel = window.berlinMediaGroupData?.strings?.closeSubmenuText || '';
		const label = isOpen ? closeLabel : openLabel;

		toggleButton.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
		toggleButton.setAttribute( 'aria-label', label );
		toggleButton.setAttribute( 'title', label );
		toggleButton.classList.toggle( 'is-open', isOpen );
	}

	/**
	 * Init submenu toggle buttons next to parent links.
	 * Runs when menu is opened (because on some setups the menu isn't in DOM yet).
	 */
	function initSubmenuToggles() {
		const root = menucontainer || menu || document;

		const parentLinks = root.querySelectorAll(
			'#primary-menu .menu-item-has-children > a, ' +
			'#primary-menu .page_item_has_children > a, ' +
			'.menu-item-has-children > a, .page_item_has_children > a'
		);

		if ( !parentLinks.length ) {
			return;
		}

		for ( let i = 0; i < parentLinks.length; ++i ) {

			// If toggle already exists, skip.
			if (
				parentLinks[ i ].parentNode &&
				parentLinks[ i ].parentNode.classList &&
				parentLinks[ i ].parentNode.classList.contains(
					'menu-link-wrap'
				)
			) {
				continue;
			}

			/*
			 * Create button element that will be used to toggle submenu visibility.
			 */
			const btn = document.createElement( 'button' );
			btn.type = 'button';
			btn.className = 'submenu-toggle';

			/*
			 * Add an icon to the button. This can be replaced with an SVG or a different character if desired.
			 */
			const icon = document.createElement('span');
			icon.className = 'submenu-toggle-icon';
			icon.setAttribute('aria-hidden', 'true');
			icon.innerHTML = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 12" focusable="false">
		<path d="M9.5 10.2 16.7 0H19l-8.4 12H8.4L0 0h2.4"/>
	</svg>
`;

			btn.appendChild(icon);
			setToggleState( btn, false );



			// Create wrapper and move link + button inside
			const wrap = document.createElement( 'div' );
			wrap.className = 'menu-link-wrap';

			const link = parentLinks[ i ];
			const li = link.parentNode;

			// Wrap before link in <li>.
			li.insertBefore( wrap, link );

			// Push link and button into wrapper.
			wrap.appendChild( link );
			wrap.appendChild( btn );

			btn.addEventListener(
				'click',
				function ( e ) {
					e.preventDefault();
					e.stopPropagation();

					const liSub = this.closest( 'li' );
					if ( ! liSub ) {
						return;
					}

					const isOpen = liSub.classList.contains( 'focus' );

					liSub.classList.toggle( 'focus', ! isOpen );
					setToggleState( this, ! isOpen );
				},
				false
			);

			if ( 'ontouchstart' in window ) {
				btn.addEventListener(
					'touchstart',
					function ( e ) {
						e.preventDefault();
						e.stopPropagation();
						this.click();
					},
					{ passive: false }
				);
			}
		}
	}

	function isMenuOpen() {
		return container.classList.contains( 'toggled' ) ||
			( menucontainer && menucontainer.classList.contains( 'toggled' ) );
	}

	function closeMenuAndFocusButton() {
		if ( !isMenuOpen() ) {
			return;
		}
		button.click();
		button.focus();
	}

	// Capture-phase that captures all focus changes.
	document.addEventListener( 'focusin', function () {
		if ( !isMenuOpen() ) {
			return;
		}

		const doc = button.ownerDocument;
		const a = doc.activeElement;
		const logo = document.querySelector( 'a.custom-logo-link' ); // <- neu

		const inside =
			( a && (
				button.contains( a ) ||
				( menucontainer && menucontainer.contains( a ) ) ||
				container.contains( a ) ||
				( logo && logo.contains( a ) ) // <- neu
			) );

		if ( !inside ) {
			closeMenuAndFocusButton();
		}
	}, true );

	button.addEventListener( 'click', function () {

		const open = container.classList.toggle( 'toggled' );

		button.setAttribute( 'aria-expanded', open );
		menu.setAttribute( 'aria-expanded', open );

		if ( menucontainer ) {
			menucontainer.classList.toggle( 'toggled', open );
		}

		if ( open ) {
			initSubmenuToggles();
		}
	} );
} )();

document.addEventListener( 'click', function ( event ) {
	const container = event.target.closest( '#mobile-navigation.toggled .nav-container' );
	if ( !container ) {
		return;
	}

	if ( event.target.closest( 'a' ) ) {
		return;
	}
	if ( event.target.closest( '.menu-hauptmenu-container,.menu-navigation-container' ) ) {
		return;
	}

	const zielButton = document.querySelector(
		'.main-navigation.toggled .menu-toggle'
	);
	if ( zielButton ) {
		zielButton.click();
	}
} );
